<div class="section-table-container" [ngClass]="{ 'beta-access-enabled': isBetaAccessPrivilegeConsumable }">
  <div class="outer-border">
    <p-button
      *ngIf="showTable && !disableField && indices.length < 16"
      type="button"
      [label]="'ADD_INDEX' | translate"
      icon="pi pi-plus"
      (onClick)="openIndexDesigner()"
      class="new-btn"
    />
  </div>
  <div class="d-flex flex-column">
    <p-table
      *ngIf="showTable && formData"
      [value]="indices"
      dataKey="sid"
      class="fil-map-table index-table"
      styleClass="p-datatable-gridlines sql-tables"
      [style]="{ width: '100%' }"
      [scrollable]="true"
    >
      <ng-template pTemplate="header">
        <tr id="index">
          <th id="index-name">{{ 'INDEX_NAME' | translate }}</th>
          <th id="index-type">{{ 'TYPE' | translate }}</th>
          <th id="index-fields">{{ 'FIELDS' | translate }}</th>
          <th class="w-100-px action-items" id="index-edit-delete"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-column let-i="rowIndex">
        <tr>
          <td class="index-column index-name text-break">
            <span>{{ column.indexName }}</span>
          </td>
          <td class="index-column index-type text-break">
            <span>{{ column.indexType }}</span>
          </td>
          <td class="index-column index-fields text-break">
            <span>{{ getFieldNames(column.fields) }}</span>
          </td>
          <td class="index-column index-edit inline-delete text-break">
            <div
              class="index-actions-icon-wrapper d-flex"
              *ngIf="
                (!column.childTables || column.childTables.length === 0) &&
                !(column.indexName === 'EMAILPrimary' && formData.name === 'Application User') &&
                !disableField
              "
            >
              <svg-icon
                (click)="showWhereUsed(column)"
                [src]="svgPaths.whereUsed.default"
                class="icon-plus cursor-pointer mr-2 where-used-icon"
                [attr.alt]="'WHERE_USED' | translate"
                aria-hidden="true"
                showDelay="100"
                hideDelay="100"
                pTooltip="{{ 'WHERE_USED' | translate }}"
                tooltipPosition="top"
              ></svg-icon>
              <svg-icon
                (click)="openIndexDesigner(column.sid, column)"
                src="assets\images\svg\edit.svg"
                class="icon-plus cursor-pointer mr-1 edit-icon"
                [attr.alt]="'EDIT' | translate"
                aria-hidden="true"
                showDelay="100"
                hideDelay="100"
                pTooltip="{{ 'EDIT' | translate }}"
                tooltipPosition="top"
                *ngIf="
                  !(
                    column.indexType === 'UNIQUE' &&
                    column?.fields.length === 1 &&
                    fieldIdMap[column?.fields[0]] === 'Sid' &&
                    formData.name === 'Application User'
                  )
                "
              ></svg-icon>
              <svg-icon
                (click)="removeIndex(column)"
                src="assets\images\svg\trash.svg"
                class="icon-plus cursor-pointer"
                [attr.alt]="'DELETE' | translate"
                aria-hidden="true"
                showDelay="100"
                hideDelay="100"
                pTooltip="{{ 'DELETE' | translate }}"
                tooltipPosition="top"
                *ngIf="
                  !(
                    (column.indexType === 'UNIQUE' || column.indexType === 'PRIMARY') &&
                    column?.fields.length === 1 &&
                    fieldIdMap[column?.fields[0]] === 'Sid'
                  )
                "
              ></svg-icon>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr class="no-records">
          <td colspan="4" class="text-center">
            {{ 'NO_INDEX_CREATED' | translate }}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
<p-dialog
  [(visible)]="showDesigner"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '50vw' }"
  appendTo="body"
  [styleClass]="isBetaAccessPrivilegeConsumable ? 'beta-access-enabled' : ''"
  [closable]="false"
>
  <ng-template pTemplate="header">
    <span class="dialog-header"
      >{{ tableName }} - {{ (!(indexFormData && indexFormData?.sid) ? 'INDEX' : 'INDEX') | translate }}
      {{
        indexFormData && indexFormData?.sid
          ? ' :
            '
          : ''
      }}
      <span class="dialog-subheader">
        {{ indexFormData && indexFormData?.sid ? formGroup.get('indexName')?.value : '' }}</span
      >
    </span>
  </ng-template>
  <div [formGroup]="formGroup" class="fk-form">
    <div class="field mb-2 d-flex form-group pl-3">
      <label for="indexName" class="col-md-8 col-form-label index-name required">{{ 'INDEX_NAME' | translate }}</label>
      <div class="ml-4 col-md-8 col-form-content">
        <input
          id="indexName"
          class="form-control form-control-sm"
          [ngClass]="{ 'error-border': submitted && formGroup.get('indexName')?.invalid }"
          pInputText
          formControlName="indexName"
          trim="blur"
          required
          maxlength="64"
          [attr.readonly]="isSidUniqueIndex ? true : null"
        />
      </div>
    </div>
    <div class="field mb-2 d-flex form-group pl-3">
      <label for="type" class="col-md-8 col-form-label required">{{ 'INDEX_TYPE' | translate }}</label>
      <div class="ml-4 col-md-8 col-form-content">
        <p-select
          [options]="modifiedTypeOptions"
          [placeholder]="'GH_SELECT_TYPE' | translate"
          optionLabel="label"
          optionValue="value"
          formControlName="indexType"
          appendTo="body"
          class="form-control"
          [ngClass]="{ 'error-border': submitted && formGroup.get('indexType')?.invalid }"
          required
        >
        </p-select>
      </div>
    </div>
    <div class="field d-flex form-group pl-3">
      <label for="fields" class="col-md-8 col-form-label required">{{ 'FIELDS' | translate }}</label>
      <div
        class="ml-4 col-md-8 col-form-content index-designer-vb-pickuplist"
        [ngClass]="{ 'error-border': (submitted && formGroup.get('fields')?.invalid)}"
      >
      <div>
          <vb-pickup-list
          [fieldIdMap]="fieldIdMap"
          [element]="fieldProperty"
          [formData]="indexFormData"
          [pickList]="pickList"
          formControlName="fields"
          [disableField]="disallowEdit"
          [isSidFieldAvlInIndex]="isSidFieldAvlInIndex"
          [errorObj]="errorObj"
        >
        </vb-pickup-list>
        </div>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-primary cancel-btn button-outlined" (click)="onCloseDesigner('true')">
      {{ 'CANCEL' | translate }}
    </button>
    <button
      type="submit"
      class="btn btn-primary btn-sm mr-2 px-3 button-filled"
      [disabled]="!formGroup.get('fields')?.value"
      (click)="saveIndex()"
    >
      {{ 'SAVE' | translate }}
    </button>
  </ng-template>
  <div class="d-flex justify-content-center align-items-center w-100" *ngIf="isLoading">
    <div class="spinner-container">
      <p-progress-spinner></p-progress-spinner>
    </div>
  </div>
</p-dialog>
<div class="d-flex justify-content-center align-items-center w-100" *ngIf="isLoading">
  <div class="spinner-container">
    <p-progress-spinner></p-progress-spinner>
  </div>
</div>
